var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _PICMap_vectors;
import { html, css, render } from 'lit';
import { base64Decoder, base64DecoderJSON, customElement, fetchApiData, fetchRestApi, loadPage, numberDecoder, openChoiceBox, PIC, PICAction, PICBase, stringDecoder } from '../Internals';
import { property, query } from 'lit/decorators.js';
import { Map, View, Overlay, Feature } from 'ol';
import OSM from 'ol/source/OSM.js';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import GeoJSON from 'ol/format/GeoJSON.js';
import { Draw, Snap } from 'ol/interaction';
import CircleStyle from 'ol/style/Circle';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import { Circle, LineString } from 'ol/geom';
import { Control } from 'ol/control';
import Icon from 'ol/style/Icon';
import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS.js';
import TileWMS from 'ol/source/TileWMS.js';
import WMTSCapabilities from 'ol/format/WMTSCapabilities.js';
import WMSCapabilities from 'ol/format/WMSCapabilities.js';
import { fromLonLat, get as getProjection } from 'ol/proj.js';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import TileLayer from 'ol/layer/Tile';
import { styleMap } from 'lit/directives/style-map.js';
import { easeIn, easeOut } from 'ol/easing.js';
import * as TurfHelpers from '@turf/helpers';
import length from '@turf/length';
import lineSliceAlong from '@turf/line-slice-along';
let PICMap = class PICMap extends PICBase {
    get vectors() {
        return __classPrivateFieldGet(this, _PICMap_vectors, "f");
    }
    set vectors(vs) {
        if (vs)
            vs.vectors = vs.vectors.map(v => {
                var _a, _b;
                if (v.properties)
                    v.properties.layerColor = (_a = v.properties.layerColor) !== null && _a !== void 0 ? _a : this.getAvailableColor();
                else
                    v.properties = { layerColor: (_b = v.layerColor) !== null && _b !== void 0 ? _b : this.getAvailableColor() };
                return v;
            });
        __classPrivateFieldSet(this, _PICMap_vectors, vs, "f");
    }
    constructor() {
        super();
        this.width = '';
        this.height = '';
        this.startCoords = []; // accepts LonLat (EPSG:4326), format: decimal degrees
        this.mapFilename = 'map';
        _PICMap_vectors.set(this, void 0);
        this.locationPoint = new VectorSource();
        this.genRanHex = (size) => { return [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join(''); };
        this.vectorLayerColors = { availableColors: [...Array(500)].map(() => `#${this.genRanHex(6)}`) };
        this.defaultVars = {
            circleFill: 'red',
            circleStroke: 'red',
            circleRadius: 6,
            circleStrokeWidth: 2,
            iconSrc: '/images/no-image.svg',
            iconSize: [25, 25],
            iconScale: 0.80,
            lineStroke: 'darkgreen',
            lineStrokeWidth: 2,
            lineFill: 'darkgreen',
            mapCenter: [1136521.2393115214, 7586969.507034603],
            mapZoom: 12,
        };
        this.viewAnimations = {
            'rotateAround': (coords) => {
                if (this.view) {
                    const rotation = this.view.getRotation();
                    this.view.animate({
                        rotation: rotation + Math.PI,
                        anchor: coords,
                        easing: easeIn,
                    }, {
                        rotation: rotation + 2 * Math.PI,
                        anchor: coords,
                        easing: easeOut,
                    });
                }
            },
            'spinTo': (coords) => {
                if (this.view) {
                    const center = this.view.getCenter();
                    if (center)
                        this.view.animate({
                            center: [
                                center[0] + (coords[0] - center[0]) / 2,
                                center[1] + (coords[1] - center[1]) / 2,
                            ],
                            rotation: Math.PI,
                            easing: easeIn,
                        }, {
                            center: coords,
                            rotation: 2 * Math.PI,
                            easing: easeOut,
                        });
                }
            },
            'flyTo': (coords, callback) => {
                if (this.view) {
                    const duration = 2000;
                    const zoom = this.view.getZoom();
                    let parts = 2;
                    let allPartsDone = false;
                    function partDone(animationIsComplete) {
                        --parts;
                        if (allPartsDone) {
                            return;
                        }
                        if (parts === 0 || !animationIsComplete) {
                            allPartsDone = true;
                            if (callback)
                                callback(animationIsComplete);
                        }
                    }
                    if (zoom) {
                        this.view.animate({
                            center: coords,
                            duration: duration,
                        }, partDone);
                        this.view.animate({
                            zoom: zoom - 1,
                            duration: duration / 2,
                        }, {
                            zoom: zoom,
                            duration: duration / 2,
                        }, partDone);
                    }
                }
            },
        };
    }
    focus() {
    }
    validateSubmit() {
        return true;
    }
    checkAndConsumeInlineData() {
        let iData = this.getAttribute('datafromprogress');
        if (iData) {
            this.vectors = base64DecoderJSON(iData);
            this.vectors.vectors.forEach(vector => {
                if (typeof vector.interaction === 'string') {
                    let b64decInteraction = JSON.parse(base64Decoder(vector.interaction));
                    if (b64decInteraction > '') {
                        vector.interaction = b64decInteraction;
                        if (typeof vector.interaction.tooltipTemplate === 'string') {
                            b64decInteraction = JSON.parse(base64Decoder(vector.interaction.tooltipTemplate));
                            if (b64decInteraction)
                                vector.interaction.tooltipTemplate = b64decInteraction;
                        }
                    }
                }
            });
            this.requestUpdate();
        }
        this.removeAttribute('datafromprogress');
    }
    connectedCallback() {
        super.connectedCallback();
        this.checkAndConsumeInlineData();
        this.addEventListener('update', this.updateMapView.bind(this));
        this.addEventListener('drawWagonsOnStation', this.drawWagonsOnStationE);
        //this.addEventListener('drawWagonsOnStation', this.customEventHandler)
        this.addEventListener('exportMap', this.customEventHandler);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('update', this.updateMapView.bind(this));
        this.removeEventListener('drawWagonsOnStation', this.drawWagonsOnStationE);
        //this.removeEventListener('drawWagonsOnStation', this.customEventHandler)
        this.removeEventListener('exportMap', this.customEventHandler);
        this.shutdown();
    }
    /**
     * Method for intercepting CustomEvents and calling the relevant internal functions
     * @param event the incoming custom event
     */
    customEventHandler(event) {
        var _a, _b, _c;
        switch (event.type) {
            case 'update':
                break;
            case 'drawWagonsOnStation':
                let stationRefno = Number((_a = event.detail.data) === null || _a === void 0 ? void 0 : _a.stationRefno);
                if (stationRefno > 0)
                    this.drawWagonsOnStation(stationRefno);
                break;
            case 'exportMap':
                let format = (_b = event.detail.data) === null || _b === void 0 ? void 0 : _b.format;
                let type = (_c = event.detail.data) === null || _c === void 0 ? void 0 : _c.type;
                this.exportMap(format, type);
                break;
            default:
                break;
        }
    }
    static get styles() {
        const defaultStyle = css `
            :host{
                --control-icon-width: 24px;
                --control-icon-height: 24px;
                --control-icon-margin: 15px;

                --control-icon-top-width: 24px;
                --control-icon-top-height: 24px;
                --control-icon-top-margin: var(--control-icon-margin);

                --map-widgets-background-color: var(--pic-backgroundColor);
                --control-layer-modal-width: 220px;
                --control-layer-modal-height: fit-content;
            }
            .fa-2x {
                font-size: 2em;
            }
            .fa {
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                font-size: 16px;
            }
            .outerContainer{
                width: 99%;
                height: 95vh;
                border-radius: 9.699px;
            }
            #tooltip {
                position: absolute;
                display: block;
                height: auto;
                width: auto;
                z-index: 100;
                background-color: transparent;
                color: black;
                pointer-events: none;
                font-weight: bold;
                transform: translateX(-18px) translateY(-18px); /* arbitrary values */
            }

            /* controls */
            .ol-control-layer, .ol-refresh, .ol-rotate, .ol-position, .ol-zoom, .ol-copyright, .ol-attribution, .ol-export {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                position: absolute;
            }

            .ol-control-layer {
                top: 10px;
                border-left: 1px solid #eeeeee;
                border-radius: 0px 3px 3px 0px;
                left: calc(100% - var(--control-icon-top-width) - var(--control-icon-top-margin) - 2px);
            }

            .ol-control-layer-modal {
                box-sizing: border-box;
                position: absolute;
                top: calc(10px + var(--control-icon-top-height) + 4px);
                left: calc(100% - var(--control-layer-modal-width) - var(--control-icon-top-margin) - 1px);
                width: var(--control-layer-modal-width);
                height: var(--control-layer-modal-height);
                border-radius: 3px;
                background-color: var(--map-widgets-background-color);
                padding: 15px;
            }
            
            .ol-refresh {
                top: 10px;
                left: calc(100% - 2 * var(--control-icon-top-width) - var(--control-icon-top-margin) - 2px);
            }

            .ol-export {
                top: 10px;
                left: calc(100% - 3 * var(--control-icon-top-width) - var(--control-icon-top-margin) - 2px);
            }

            .ol-rotate {
                top: calc(100% - 4 * var(--control-icon-height) - var(--control-icon-margin) - 12px);
                left: calc(100% - var(--control-icon-width) - var(--control-icon-margin));
            }
            
            .ol-position {
                top: calc(100% - 3 * var(--control-icon-height) - var(--control-icon-margin) - 12px);
                left: calc(100% - var(--control-icon-width) - var(--control-icon-margin));
            }

            .ol-zoom {
                top: calc(100% - 2 * var(--control-icon-height) - var(--control-icon-margin) - 8px);
                left: calc(100% - var(--control-icon-width) - var(--control-icon-margin));
            }

            .ol-copyright {
                /* bottom: 0;
                left: 0; */
                top: calc(100% - 1 * var(--control-icon-height) - var(--control-icon-margin));
                right: calc(100% - var(--control-icon-width) - var(--control-icon-margin));
                /* left: calc(100% - var(--control-icon-width) - var(--control-icon-margin)); */
            }

            .ol-attribution {
                z-index: -1;
                font-size: 12px;
                /* top: calc(100% - var(--control-icon-margin)); */
                top: calc(100% - 1 * var(--control-icon-height) - var(--control-icon-margin));
                left: calc(3 * var(--control-icon-top-width) - var(--control-icon-margin) - 20px);
                /* left: 20px; */
            }

            .ol-attribution a:visited {
                color: blue
            }

            .ol-attribution button {
                display: none;
            }

            .ol-attribution ul {
                padding-inline-start: 0px;
                margin: 0;
            }

            .ol-attribution li {
                list-style-type: none;
                background-color: rgb(255 255 255 / 75%);
                padding: 4.5px 15px;
            }

            .ol-zoom-out, .ol-zoom-in, .ol-rotate-reset, .ol-position-locate, .ol-control-layer-openmodal, .ol-refresh-button, .ol-copyright-button, .ol-export-button {
                background-color: var(--map-widgets-background-color);
                width: var(--control-icon-width);
                height: var(--control-icon-height);
                border: 0;
                padding: 0;
                color: var(--pic-onSurfaceMediumColor);
            }
            :where(.ol-zoom-out, .ol-zoom-in, .ol-rotate-reset) svg {
                outline: none;
                width: var(--control-icon-width);
                height: var(--control-icon-height);
            }

            .ol-position-locate svg {
                outline: none;
            }

            :where(.ol-zoom-out, .ol-zoom-in, .ol-rotate-reset, .ol-position-locate, .ol-control-layer-openmodal, .ol-refresh-button, .ol-copyright, .ol-export-button):hover {
                cursor: pointer;
                filter: invert(0.1);
            }
            
            .ol-control-layer-openmodal, .ol-refresh-button {
                width: var(--control-icon-top-width);
                height: var(--control-icon-top-height);
                /* border-radius: 3px; */
            }

            .ol-control-layer-openmodal {
                border-radius: 0px 3px 3px 0px;
            }

            .ol-refresh-button {
                border-radius: 3px 0px 0px 3px
            }
            
            .ol-rotate-reset{
                border-radius: 3px 3px 0px 0px;
            }

            .ol-position-locate {
                border-radius: 0px 0px 3px 3px;
                border-top: 1px solid #eeeeee;
            }
            .ol-zoom-in {
                border-radius: 3px 3px 0px 0px;
            }

            .ol-zoom-out {
                border-radius: 0px 0px 3px 3px;
                border-top: 1px solid #eeeeee;
            }

            .ol-copyright-button {
                border-radius: 3px;
                cursor: pointer;
            }

            .hidden {
                display: none;
                //visibility: hidden;
            }

            .divider {
                border-top: 1px solid #eeeeee;
                border-radius: 5px;
            }

            .layer-modal-title {
                margin-top: 5px;
                margin-bottom: 5px;
            }

            .layer-modal-top-items{
                display: flex;
                flex-direction: row;
                justify-content: center;
                gap: 35px;
                margin-top: 8px;
            }

            .layer-modal-top-item{
                display: flex;
                flex-direction: column;
                justify-items: flex-start;
            }

            .layer-modal-maptype-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }

            .layer-modal-maptype-item:hover {
                cursor: pointer
            }

            .layer-modal-body{
                display: flex;
                flex-direction: column;
                justify-items: flex-start;
            }
            
            .layer-modal-layer-item{
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                padding-left: 10px;
            }

            .layerNames {
                margin-left: 14px;
                padding-top: 2px;
            }
  
            .layerCircle, .layerArrow {
                padding-top: 4px;
                margin-left: 5px;
            }

            .layer-modal-layer-item:hover {
                cursor: pointer;
            }

            .image-default, .image-satellite {
                border-radius: 3px;
            }

            .active {
                border: 2px solid #1A73E8;
                background: #FFF;
            }

            @keyframes fadeInLeft {
                from { opacity: 0; transform: translateX(-20px); }
                to { opacity: 1; transform: translateX(0); }
            }

            @keyframes fadeOutLeft {
                from { opacity: 1; transform: translateX(0); }
                to { opacity: 0; transform: translateX(-20px); }
            }

            .fade-in-left {
                animation: fadeInLeft 0.5s ease-in forwards;
            }

            .fade-out-left {
                animation: fadeOutLeft 0.5s ease-out forwards;
            }

            .hr-wagon-overlay {
                color: black !important;
                background-color: transparent !important;
                border-radius: 3px;
                background-image: radial-gradient(transparent 25%, red);
                border: 1px solid #fff;
                font-weight: bolder;
                font-size: 1.1em;
                padding: 6px;
                transform: translate(0, -7px);
            }

            .hr-wagon-overlay-arrow {
                position: absolute;
                left: 0.5em;
                bottom: -9px; /* might be too arbitrary */
                height: 0.5rem;
                width: 1rem;
                display: block;
            }

            .hr-wagon-overlay-arrow::before {
                position: absolute;
                display: block;
                bottom: 0;
                content: "";
                border-color: transparent;
                border-style: solid;
                border-width: 0.5rem 0.5rem 0;
                border-top-color: rgba(0, 0, 0, 0.1);
            }

            .hr-wagon-overlay-arrow::after {
                position: absolute;
                display: block;
                bottom: 1px;
                content: "";
                border-color: transparent;
                border-style: solid;
                border-width: 0.5rem 0.5rem 0;
                border-top-color: rgba(255, 255, 255, 1);
            }

            /* .iconActive {
                color: black;
            } */
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    getMapStyle() {
        return {
            'width': this.width,
            'height': this.height,
        };
    }
    shutdown() {
        var _a, _b;
        this.map.dispose();
        (_b = (_a = this.vectors) === null || _a === void 0 ? void 0 : _a.vectors) === null || _b === void 0 ? void 0 : _b.forEach(v => { var _a; return (_a = v.VectorLayer) === null || _a === void 0 ? void 0 : _a.dispose(); });
        this.map.setTarget(undefined);
        //@ts-ignore
        this.map = undefined;
    }
    getFeatureValues(feature) {
        if (feature) {
            return Object.keys(feature === null || feature === void 0 ? void 0 : feature.getProperties()).map((f) => {
                return html `${typeof (feature === null || feature === void 0 ? void 0 : feature.get(f)) == 'object' ? '' : `${f} : ${feature === null || feature === void 0 ? void 0 : feature.get(f)}\n`}`;
            });
        }
    }
    getFeatureValuesAsLoadpageParams(feature) {
        if (feature) {
            return Object.keys(feature === null || feature === void 0 ? void 0 : feature.getProperties()).map((f) => {
                return `${typeof (feature === null || feature === void 0 ? void 0 : feature.get(f)) == 'object' ? '' : `${f}=${feature === null || feature === void 0 ? void 0 : feature.get(f)}`}`;
            }).join(',');
        }
    }
    getParentVectorFromFeature(iFeat) {
        var _a;
        return (_a = this.vectors) === null || _a === void 0 ? void 0 : _a.vectors.find((v) => { var _a, _b; return (_b = (_a = v.VectorLayer) === null || _a === void 0 ? void 0 : _a.getSource()) === null || _b === void 0 ? void 0 : _b.getFeatures().find(f => f === iFeat); });
    }
    getOverlayPopUp() {
        let popDiv = document.createElement('div');
        let pop = new Overlay({ element: popDiv });
        //TODO: use layerfilter to optmise search
        // let lf = (l: any) => { 
        //     let result = this.vectors?.vectors.find((v) => v.VectorLayer === l);
        //     // console.log('input layer', l, 'result', result, result ? true : false);
        //     return result ? true : false;
        // };
        // this.map.on('click',  (e) => console.log('getFeatures', this.map.getFeaturesAtPixel(e.pixel, {layerFilter: lf})));
        // this.map.on('click',  (e) => this.map.forEachFeatureAtPixel(e.pixel, (f) => console.log('forEachFeature', f), {layerFilter: lf}))
        this.map.on('click', (e) => {
            var _a;
            let feat = this.map.forEachFeatureAtPixel(e.pixel, (f, l) => { return f; });
            if (feat) {
                let parentVector = this.getParentVectorFromFeature(feat);
                if (parentVector) {
                    if (parentVector.interaction.loadPagePath) {
                        loadPage(parentVector.interaction.loadPagePath, `${this.getFeatureValuesAsLoadpageParams(feat)},${(_a = parentVector.interaction.loadPageParms) !== null && _a !== void 0 ? _a : ''},lng=${e.coordinate[0]},lat=${e.coordinate[1]}`, { drawMode: 'picMap' });
                    }
                }
            }
        });
        return pop;
    }
    addOverlays() {
        this.map.addOverlay(this.getOverlayPopUp());
    }
    addTooltipInteraction(src, layer) {
        if (typeof layer.interaction.tooltipTemplate !== 'object')
            return;
        this.map.on('pointermove', (e) => {
            var _a;
            if (e.dragging)
                return;
            const pixel = this.map.getEventPixel(e.originalEvent);
            const feature = e.originalEvent.target.closest('.ol-control')
                ? undefined
                : this.map.forEachFeatureAtPixel(pixel, function (feature, layerOL) {
                    if (layerOL === layer.VectorLayer)
                        return feature;
                });
            if (feature && typeof layer.interaction.tooltipTemplate === 'object') {
                let template = layer.interaction.tooltipTemplate.template;
                let templateKeys = layer.interaction.tooltipTemplate.properties.split(',');
                if (templateKeys.length === 0) { }
                else if (template === '')
                    template = (_a = feature.get(templateKeys[0])) !== null && _a !== void 0 ? _a : '';
                else {
                    for (let i = 0; i < templateKeys.length; i++) {
                        let r = new RegExp(`&${i + 1}`, 'g');
                        let val = feature.get(templateKeys[i]);
                        if (val == undefined)
                            val = '';
                        template = template.replace(r, val);
                    }
                }
                this.tooltipContainer.textContent = template; //to make HTML work, use innerHTML, with restrictions
                this.tooltipContainer.style.display = '';
                // this.tooltipContainer.style.left = pixel[0] + 'px'
                // this.tooltipContainer.style.top = pixel[1] + 'px'
                //Examples use above, but below works.......
                this.tooltipContainer.style.left = e.originalEvent.clientX + 'px';
                this.tooltipContainer.style.top = e.originalEvent.clientY + 'px';
            }
            else {
                this.tooltipContainer.style.display = 'none';
                this.tooltipContainer.textContent = '';
            }
        });
        this.map.getTargetElement().addEventListener('pointerleave', (e) => {
            this.tooltipContainer.style.display = 'none';
            this.tooltipContainer.textContent = '';
        });
        /*
            this.map.on('pointermove', (e) => {
            if (e.dragging) return
            const pixel = this.map.getEventPixel(e.originalEvent)
            const feature = e.originalEvent.target.closest('.ol-control')
            ? undefined
            : this.map.forEachFeatureAtPixel(pixel, function (feature) {
                return feature;
            });
            if (feature && feature.get('spornummer')) {
                let trackNumber = (feature.get('spornummer') as string).replace(/_/g, ' ')
                this.tooltipContainer.textContent = trackNumber
                this.tooltipContainer.style.display = ''
                // this.tooltipContainer.style.left = pixel[0] + 'px'
                // this.tooltipContainer.style.top = pixel[1] + 'px'
                //Examples use above, but below works.......
                this.tooltipContainer.style.left = e.originalEvent.clientX + 'px'
                this.tooltipContainer.style.top = e.originalEvent.clientY + 'px'
            } else {
                this.tooltipContainer.style.display = 'none'
                this.tooltipContainer.textContent = ''
            }
        })
        this.map.getTargetElement().addEventListener('pointerleave', (e) => {
            this.tooltipContainer.style.display = 'none'
            this.tooltipContainer.textContent = ''
        })
        */
    }
    addTraceInteraction(src) {
        //Trace geoJSON layer interaction
        // this.map.addInteraction(new Draw({
        //     type: 'LineString',
        //     source: src,
        //     trace: true,
        //     traceSource: src,
        //     style: {
        //         'stroke-color': 'rgba(255, 255, 100, 0.5)',
        //         'stroke-width': 1.5,
        //         'fill-color': 'rgba(255, 255, 100, 0.25)',
        //         'circle-radius': 6,
        //         'circle-fill-color': 'rgba(255, 255, 100, 0.5)',
        //       }
        // }))
        this.map.addInteraction(new Snap({
            source: src
        }));
    }
    //TODO: implement, currentlocation / find me
    addCurrentPosControlButton() {
        let buttonDiv = document.createElement('div');
        buttonDiv.classList.add('ol-position');
        render(html `
            <button class="ol-position-locate ol-unselectable"
                @click=${() => { if (!this.locationPoint.isEmpty()) {
            this.map.getView().fit(this.locationPoint.getExtent(), { maxZoom: 18, duration: 500 });
        } }}
                >${this.mapSVG.position}${this.renderToolTip('Show current location', ['left'], { mainAxis: 100, crossAxis: 15 })}</button>
        `, buttonDiv);
        this.map.addControl(new Control({ element: buttonDiv }));
    }
    setCurrentPos() {
        // navigator.geolocation.watchPosition((pos) => {
        //     const coords = [pos.coords.longitude, pos.coords.latitude];
        //     const accuracy = circular(coords, pos.coords.accuracy);
        //     let features = [new Feature(accuracy.transform('EPSG:4326', this.map.getView().getProjection())), new Feature(new Point(fromLonLat(coords)))]
        //     this.locationPoint.clear(true)
        //     this.locationPoint.addFeatures(features);
        // }, (err)=>console.log(err), {enableHighAccuracy: true})
        this.addCurrentPosControlButton();
    }
    loadFromAPI(vs, v) {
        var _a;
        let options = {
            path: (_a = v.link) !== null && _a !== void 0 ? _a : '',
            method: 'GET',
            errorReturn: true,
            formatOutput: 'json',
            systemId: null
        };
        fetchApiData('', options).then(data => {
            var _a;
            let f = (_a = vs.getFormat()) === null || _a === void 0 ? void 0 : _a.readFeatures(data);
            if (f) {
                vs.addFeatures(f);
            }
        }).catch(err => console.log('failure', err));
    }
    APILoader(vs, v) {
        return (extent, resolution, projection, success, failure) => {
            var _a;
            let options = {
                path: (_a = v.link) !== null && _a !== void 0 ? _a : '',
                method: 'GET',
                errorReturn: true,
                formatOutput: 'json',
                systemId: null
            };
            fetchApiData('', options).then(data => {
                var _a;
                /* dataprojection set, because openlayes does not read / respect the crs value from the geojson */
                let f = (_a = vs.getFormat()) === null || _a === void 0 ? void 0 : _a.readFeatures(data, { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' });
                if (f && success) {
                    f.forEach(feat => {
                        var _a, _b, _c, _d, _e;
                        let p = feat.getProperties();
                        let iconSrc;
                        let rotation = 0;
                        let size = this.defaultVars.iconSize;
                        let scale = this.defaultVars.iconScale;
                        let color = v.properties.layerColor;
                        if (p) {
                            iconSrc = p.hasOwnProperty('iconSrc') ? p.iconSrc : iconSrc;
                            rotation = p.hasOwnProperty('rotation') ? p.rotation * Math.PI / 180 : rotation; //converting degrees to radians
                            size = p.hasOwnProperty('size') ? p.size : size;
                            scale = p.hasOwnProperty('scale') ? p.scale : scale;
                            color = p.hasOwnProperty('color') ? p.color : color;
                            v.properties = { iconSrc: iconSrc, iconSize: size, iconScale: scale, layerColor: color, iconRotation: rotation };
                        }
                        if (iconSrc)
                            feat.setStyle(new Style({ image: new Icon({ src: iconSrc, size: size, scale: scale, color: color, rotation: rotation }) }));
                        else if (p.style) {
                            //take style from ...feature?
                            try {
                                let featStyle = JSON.parse(p.style);
                                let stroke = ((_a = featStyle.stroke) === null || _a === void 0 ? void 0 : _a.color) ? new Stroke({ color: featStyle.stroke.color, width: (_b = featStyle.stroke) === null || _b === void 0 ? void 0 : _b.width }) : undefined;
                                let fill = ((_c = featStyle.fill) === null || _c === void 0 ? void 0 : _c.color) ? new Fill({ color: featStyle.fill.color }) : undefined;
                                let s = new Style({
                                    //stroke: new Stroke({color: 'red', width: 4})
                                    stroke: stroke,
                                    fill: fill,
                                });
                                feat.setStyle(s);
                            }
                            catch (e) {
                                let s = new Style({
                                    stroke: new Stroke({ color: 'red', width: 4 })
                                });
                                feat.setStyle(s);
                            }
                        }
                        else { //default to circle
                            let defaultCircle = new CircleStyle({
                                radius: this.defaultVars.circleRadius,
                                fill: new Fill({ color: (_d = v === null || v === void 0 ? void 0 : v.properties.layerColor) !== null && _d !== void 0 ? _d : this.defaultVars.circleFill }),
                                stroke: new Stroke({ width: this.defaultVars.circleStrokeWidth, color: (_e = v === null || v === void 0 ? void 0 : v.properties.layerColor) !== null && _e !== void 0 ? _e : this.defaultVars.circleStroke })
                            });
                            feat.setStyle(new Style({ image: defaultCircle }));
                        }
                    });
                    vs.addFeatures(f);
                    this.renderLayerControlModal();
                    success(vs.getFeatures());
                }
            }).catch(err => failure());
        };
    }
    refreshAllVectorLayers() {
        var _a;
        (_a = this.vectors) === null || _a === void 0 ? void 0 : _a.vectors.forEach(v => this.refreshVectorLayer(v));
    }
    refreshVectorLayer(v) {
        var _a;
        if (v.VectorLayer) {
            (_a = v.VectorLayer.getSource()) === null || _a === void 0 ? void 0 : _a.refresh();
        }
    }
    getAPIStyle(v) {
        var _a, _b, _c, _d;
        let p = new CircleStyle({
            radius: this.defaultVars.circleRadius,
            fill: new Fill({ color: (_a = v === null || v === void 0 ? void 0 : v.properties.layerColor) !== null && _a !== void 0 ? _a : this.defaultVars.circleFill }),
            stroke: new Stroke({ width: this.defaultVars.circleStrokeWidth, color: (_b = v === null || v === void 0 ? void 0 : v.properties.layerColor) !== null && _b !== void 0 ? _b : this.defaultVars.circleStroke })
        });
        let pi = new Style({
            fill: new Fill({ color: (_c = v === null || v === void 0 ? void 0 : v.properties.layerColor) !== null && _c !== void 0 ? _c : this.defaultVars.circleFill }),
            stroke: new Stroke({ color: (_d = v === null || v === void 0 ? void 0 : v.properties.layerColor) !== null && _d !== void 0 ? _d : this.defaultVars.circleFill, width: this.defaultVars.circleStrokeWidth }),
            image: p
        });
        return pi;
    }
    getVectorStyle(v) {
        var _a, _b;
        return new Style({
            stroke: new Stroke({
                width: this.defaultVars.lineStrokeWidth,
                color: (_a = v.properties.layerColor) !== null && _a !== void 0 ? _a : this.defaultVars.lineStroke,
            }),
            fill: new Fill({ color: (_b = v.properties.layerColor) !== null && _b !== void 0 ? _b : this.defaultVars.lineFill }),
        });
    }
    getLinkVectorSource(v) {
        let vs = new VectorSource({
            format: new GeoJSON( /*{dataProjection:'EPSG:4326', featureProjection:'EPSG:3857'}*/),
            url: v.useAPI ? undefined : v.link,
        });
        if (v.useAPI) {
            vs.setLoader(this.APILoader(vs, v));
        }
        if (v.interaction.trace)
            this.addTraceInteraction(vs);
        if (v.interaction.tooltipTemplate || v.interaction.tooltipPath)
            this.addTooltipInteraction(vs, v);
        return vs;
    }
    getLinkVectorLayer(v) {
        return new VectorLayer({
            source: this.getLinkVectorSource(v),
            style: v.useAPI ? this.getAPIStyle(v) : this.getVectorStyle(v),
        });
    }
    getAvailableColor() {
        let returnColorStr = this.vectorLayerColors.availableColors[0];
        this.vectorLayerColors.availableColors = this.vectorLayerColors.availableColors.slice(1);
        return returnColorStr;
    }
    addLayers() {
        if (this.vectors && this.vectors.vectors && Array.isArray(this.vectors.vectors)) {
            this.vectors.vectors.forEach(v => {
                if (v.link) {
                    if (!v.VectorLayer)
                        v.VectorLayer = this.getLinkVectorLayer(v);
                    if (v.refreshTimer) {
                        setInterval(() => this.refreshVectorLayer(v), v.refreshTimer * 1000);
                    }
                }
                if (v.VectorLayer) {
                    let existingLayer = this.map.getAllLayers().find(l => l == v.VectorLayer);
                    if (existingLayer)
                        this.refreshVectorLayer(v);
                    else
                        this.map.addLayer(v.VectorLayer);
                }
            });
        }
        // This adds, my location
        this.map.addLayer(new VectorLayer({ source: this.locationPoint }));
    }
    toggleLayer(v) {
        var _a, _b;
        (_a = v.VectorLayer) === null || _a === void 0 ? void 0 : _a.setVisible(!((_b = v.VectorLayer) === null || _b === void 0 ? void 0 : _b.getVisible()));
    }
    getWMSOptions() {
        console.log('get WMSOptions called');
        // https://api.dataforsyningen.dk/ddm?service=WMS&request=GetCapabilities
        let prefix = `https://rndapi.picit.dk/tile/`;
        let baseUrl = `${prefix}TileSrv?tileset=ddm&tileserver=dataforsyningen`;
        let capabilitiesUrl = `${baseUrl}&Service=WMS&Request=GetCapabilities&filename=WMS_Capabilities_DDM.xml`;
        return fetch(capabilitiesUrl)
            .then(response => {
            if (response.ok)
                return response.text();
            else
                throw new Error('Fetch WMTS Capabilities failed');
        })
            .then(data => {
            let WMSParser = new WMSCapabilities();
            let parsedData = WMSParser.read(data);
            //https://api.dataforsyningen.dk/ddm?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=TRUE&LAYERS=ddm_50m_dybde&STYLES=&WIDTH=256&HEIGHT=256&CRS=EPSG%3A25832&BBOX=765609%2C6052132%2C970638%2C6257161
            console.log('WMS Parser result:', parsedData);
            let boundingBox = parsedData.Capability.Layer.EX_GeographicBoundingBox;
            let layers = parsedData.Capability.Layer.Layer;
            let layer = layers[2];
            let capUrl = parsedData.Capability.Request.GetMap.DCPType[0].HTTP.Get.OnlineResource;
            let ext = layer.BoundingBox.extent;
            console.log(boundingBox, layer);
            let options = {
                extent: ext,
                // url: capUrl,
                url: 'https://api.dataforsyningen.dk/ddm',
                params: { 'LAYERS': layer.Name, 'TILED': 'TRUE', 'TRANSPARENT': 'TRUE' },
                serverType: 'geoserver',
                transition: 0,
            };
            return options;
        })
            .catch(err => {
            console.log(err);
            return Promise.reject();
        });
    }
    getWMTSOptions() {
        let prefix = `https://rndapi.picit.dk/tile/`;
        let baseUrl = `${prefix}TileSrv?tileset=GeoDanmarkOrto/orto_foraar_wmts&tileserver=datafordeler`;
        let capabilitiesUrl = `${baseUrl}&Service=WMTS&Request=GetCapabilities&filename=WMTS_Capabilities_OrtoF.xml`;
        let extent = [120000, 5661139.2, 1378291.2, 6500000];
        proj4.defs('EPSG:25832', "+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs");
        register(proj4);
        let dkProjection = getProjection('EPSG:25832');
        dkProjection === null || dkProjection === void 0 ? void 0 : dkProjection.setExtent(extent);
        return fetch(capabilitiesUrl)
            .then((response) => {
            if (response.ok)
                return response.text();
            else
                throw new Error('Fetch WMTS Capabilities failed');
        })
            .then((data) => {
            let WMTSParser = new WMTSCapabilities();
            let parsedData = WMTSParser.read(data);
            let options = optionsFromCapabilities(parsedData, {
                layer: 'orto_foraar_wmts',
                matrixSet: 'KortforsyningTilingDK',
                projection: dkProjection,
                transition: 0,
            });
            return options;
        })
            .catch(err => {
            console.log(err);
            /* code from: https://github.com/DAF-kodeeksempler/skaermkortwmts/blob/main/js/index.js */
            /* Decided to only use the server config from get capabilities */
            return Promise.reject();
        });
    }
    createDefaultMapLayer() {
        // this.defaultTileLayer = new WebGLTileLayer({ source: new OSM({ url: 'https://tile.picit.dk/osm/osm/{z}/{x}/{y}.png' })});
        this.defaultTileLayer = new TileLayer({ source: new OSM({ url: 'https://tile.picit.dk/osm/osm/{z}/{x}/{y}.png' }), preload: Infinity });
    }
    createSateliteMap() {
        this.getWMTSOptions().then((options) => this.createSateliteLayer(options));
    }
    createSateliteLayer(options) {
        if (options && !this.sateliteTileLayer) {
            this.sateliteTileLayer = new TileLayer({ source: new WMTS(options), preload: Infinity });
            if (this.map && this.sateliteTileLayer) {
                this.map.getLayers().insertAt(1, this.sateliteTileLayer);
            }
        }
        // this.createOceanMap();
    }
    createOceanMap() {
        console.log('createOcenMap called');
        this.getWMSOptions().then(options => this.createOceanLayer(options));
    }
    createOceanLayer(options) {
        if (options && !this.oceanTileLayer) {
            this.oceanTileLayer = new TileLayer({ source: new TileWMS(options) });
            if (this.map && this.oceanTileLayer) {
                this.map.addLayer(this.oceanTileLayer);
            }
        }
    }
    zoomToLayer(v) {
        var _a, _b;
        if (this.view) {
            let f = (_b = (_a = v.VectorLayer) === null || _a === void 0 ? void 0 : _a.getSource()) === null || _b === void 0 ? void 0 : _b.getFeatures();
            if (f && f.length > 0) {
                let p = f[0].getGeometry();
                if (p) {
                    let updateDetails = {
                        id: this.id_,
                        coordinateType: 'EPSG:3857',
                        coordinates: p.getFirstCoordinate(),
                        zoomLevel: 'fit',
                        // callBack: () => this.view.fit(p as SimpleGeometry, {padding: [170, 50, 30, 150]}) 
                    };
                    this.callUpdateMapView(updateDetails);
                    // this.view.fit(p as SimpleGeometry, {padding: [170, 50, 30, 150]});
                }
            }
        }
    }
    callUpdateMapView(updateDetails, a) {
        if (!updateDetails)
            updateDetails =
                {
                    id: this.id_,
                    coordinateType: 'EPSG:3857',
                    coordinates: this.startCoords.length > 0 ? fromLonLat(this.startCoords) : this.defaultVars.mapCenter,
                    zoomLevel: 7
                };
        if (a)
            updateDetails.animation = a;
        this.dispatchEvent(new CustomEvent('updateMapView', { detail: updateDetails }));
    }
    updateMapView(e) {
        if (this.view) {
            let updateDetails = e.detail;
            if (e.detail.data)
                updateDetails = e.detail.data;
            if (updateDetails && updateDetails.id === this.id_) {
                console.log('reacting to update view', updateDetails);
                //Default to longitude / lattitude
                let gotoCoordinates = updateDetails.coordinateType == 'EPSG:3857' ? updateDetails.coordinates : fromLonLat(updateDetails.coordinates);
                switch (updateDetails.animation) {
                    case 'rotateAround':
                        this.viewAnimations.rotateAround(gotoCoordinates);
                        break;
                    case 'spinTo':
                        this.viewAnimations.spinTo(gotoCoordinates);
                        break;
                    default:
                    case 'flyTo':
                        this.viewAnimations.flyTo(gotoCoordinates, updateDetails.callBack);
                        break;
                }
            }
        }
    }
    //This is a future feature, for drawing lines with mouse folowing layer
    drawLineOnLayer(startCoordinates, endCoordinates, v) {
        var _a, _b, _c;
        if (v === null || v === void 0 ? void 0 : v.VectorLayer) {
            //TODO: this layer needs to be made avaliable in the addlayers
            let drawLayer = new VectorLayer({
                source: new VectorSource(),
                style: {
                    'stroke-color': 'red',
                    'stroke-width': 2,
                    'fill-color': 'red',
                }
            });
            let snapInteraction = new Snap({
                source: (_a = v.VectorLayer.getSource()) !== null && _a !== void 0 ? _a : undefined,
            });
            let drawInteraction = new Draw({
                type: 'LineString',
                source: (_b = drawLayer.getSource()) !== null && _b !== void 0 ? _b : undefined,
                trace: true,
                traceSource: (_c = v.VectorLayer.getSource()) !== null && _c !== void 0 ? _c : undefined,
                style: {
                    'stroke-color': 'red',
                    'stroke-width': 3,
                    'fill-color': 'red',
                    'circle-radius': 6,
                    'circle-fill-color': 'rgba(255, 255, 100, 0.5)',
                }
            });
            this.map.addInteraction(drawInteraction);
            this.map.addInteraction(snapInteraction);
        }
    }
    testDrawLineOnLayer() {
        this.drawLineOnLayer(undefined, undefined, this.vectors.vectors[0]);
    }
    createCircleFeature(center, radius) {
        return new Feature({ geometry: new Circle(center, radius) });
    }
    createLineString(coordinates) {
        return new LineString(coordinates);
    }
    createLineStringFeature(coordinates, lineName) {
        return new Feature({ geometry: this.createLineString(coordinates), name: lineName !== null && lineName !== void 0 ? lineName : '' });
    }
    createLayer(features, strokeColor, strokeWith, fillColor) {
        return new VectorLayer({
            source: new VectorSource({ features: features }),
            style: new Style({ fill: new Fill({ color: fillColor }), stroke: new Stroke({ color: strokeColor, width: strokeWith }) })
        });
    }
    addLayerToVectorList(layer, layerName, color, requestUpdate) {
        var _a;
        let layerColor = color !== null && color !== void 0 ? color : this.getAvailableColor();
        let vector = { interaction: { trace: true }, layerName: layerName !== null && layerName !== void 0 ? layerName : 'testLayer', VectorLayer: layer, properties: { layerColor: layerColor } };
        if ((_a = this.vectors) === null || _a === void 0 ? void 0 : _a.vectors)
            this.vectors.vectors.push(vector);
        if (requestUpdate)
            this.requestUpdate();
        return vector;
    }
    drawCircle(center, radius, circleName, color) {
        let layerColor = color !== null && color !== void 0 ? color : this.getAvailableColor();
        let circleFeature = this.createCircleFeature(center, radius);
        let layer = this.createLayer([circleFeature], layerColor, 3, layerColor);
        return this.addLayerToVectorList(layer, circleName, layerColor);
    }
    drawLine(coordinates, lineName, color) {
        let layerColor = color !== null && color !== void 0 ? color : this.getAvailableColor();
        let lineFeature = this.createLineStringFeature(coordinates, lineName);
        let layer = this.createLayer([lineFeature], layerColor, 3, layerColor);
        return this.addLayerToVectorList(layer, lineName, layerColor);
    }
    //$0.fetchFileAndRunScript('/scripts/lib/stationerfeatures.json', ["loadedJsonData", "return loadedJsonData.find(x => x.abbr == 'Fa').Features.filter(f => f.properties.spornummer == '211')"])
    fetchFileAndRunScript(URI, funcStr) {
        fetch(URI)
            .then((res) => {
            if (res.ok)
                return res.json();
            else
                new Error('Fetch file failed');
        })
            .then((data) => {
            console.log('data fetched', data);
            let f = new Function(...funcStr);
            console.log('made function', f);
            console.log(f(data));
        })
            .catch((err) => {
            console.log(err);
        });
    }
    //TODO draw wagon/feature on line, dist
    //TODO color wagon according to prop
    //TODO HR "tooltip" / hover
    //TODO tooltip/table according to data
    //TODO get data/check data
    //TODO track hover / tooltip trackName
    //TODolater, turf has a shortestPath function
    drawFeaturesOnLine(features, line, vectorSource) {
        line.transform('EPSG:900913', 'EPSG:4326'); //find a better way to do this - transform feature so turf can work with it
        //@ts-ignore
        let coords = line.getCoordinates();
        let dist = 0;
        let bufferDist = 0.5;
        const format = new GeoJSON();
        let turfLine = TurfHelpers.lineString(coords);
        const lineLength = length(turfLine, { units: 'meters' });
        let defaultLength = 5; //length(turfLine, {units: 'meters'}) * 0.05
        features.forEach((feature, idx) => {
            var _a, _b, _c;
            //let featureLength = feature?.length ?? defaultLength
            let featureLength = (feature === null || feature === void 0 ? void 0 : feature.rangeMax) / 1000;
            if (isNaN(featureLength) || featureLength == null)
                featureLength = defaultLength;
            if (dist > lineLength || dist + featureLength > lineLength)
                return;
            let drawLength = featureLength * 0.85; //purely for getting a better overview of wagons...
            let lineSlice = lineSliceAlong(turfLine, dist, dist + drawLength, { units: 'meters' });
            const line = format.readFeature(lineSlice);
            (_a = line.getGeometry()) === null || _a === void 0 ? void 0 : _a.transform('EPSG:4326', 'EPSG:3857');
            line.set('hasRid', feature.hasRID ? true : false);
            line.set('hasHighRisk', feature.hasHighRisk ? true : false);
            line.set('type', 'w');
            line.set('data', feature);
            vectorSource.addFeature(line);
            dist += featureLength + bufferDist;
            if (feature.hasHighRisk) { //add HR overlay
                let box = document.createElement('div');
                box.classList.add('hr-wagon-overlay');
                box.textContent = 'HR';
                if (Number(this.map.getView().getZoom()) < 14) {
                    box.style.display = 'none';
                }
                let boxArrow = document.createElement('div');
                boxArrow.classList.add('hr-wagon-overlay-arrow');
                box.appendChild(boxArrow);
                let HROverlay = new Overlay({
                    element: box,
                    id: 'hrOverlay-' + feature.wgnNo,
                    //@ts-ignore
                    position: (_c = (_b = line.getGeometry()) === null || _b === void 0 ? void 0 : _b.getFlatMidpoint()) !== null && _c !== void 0 ? _c : [],
                    positioning: 'top-center',
                    offset: [0, -35]
                });
                this.map.addOverlay(HROverlay);
            }
        });
        line.transform('EPSG:4326', 'EPSG:900913'); //Transform feature back to correct projection
    }
    drawWagonsOnStationE(event) {
        var _a;
        let stationRefno = (_a = event.detail.data) === null || _a === void 0 ? void 0 : _a.stationRefno;
        if (stationRefno > 0)
            this.drawWagonsOnStation(stationRefno);
    }
    async drawWagonsOnStation(stationRefno) {
        //0. clear prvLayer + setup
        //1. fetch wagons on station (strkafs, or Abbr), backend is responsible for splitting / returning all
        //2. find/filter all track features
        //3. call drawFeaturesOnLine pr track with wagons and line
        //4. profit
        var _a, _b, _c, _d;
        //0
        let oldLayer = this.map.getAllLayers().find(layer => layer.getProperties().name === 'wagons');
        if (oldLayer)
            this.map.removeLayer(oldLayer);
        //remove hr-overlays
        (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.hr-wagon-overlay').forEach((el) => {
            el.remove();
        });
        const def_style = new Style({
            fill: new Fill({
                color: 'rgba(0, 128, 0, 1)'
            }),
            stroke: new Stroke({
                color: 'rgba(0, 128, 0, 1)',
                width: 5,
                lineCap: 'round'
            })
        });
        const rid_style = new Style({
            fill: new Fill({
                color: 'rgba(255, 0, 0, 1)'
            }),
            stroke: new Stroke({
                color: 'rgba(255, 0, 0, 1)',
                width: 5,
                lineCap: 'round'
            })
        });
        const selectWagonStyle = (feature) => {
            return feature.get('hasRid') ? rid_style : def_style;
        };
        this.map.getLayers().forEach(layer => {
            if (layer.get('name') === 'wagons') {
                this.map.removeLayer(layer);
            }
        });
        let vectorSource = new VectorSource();
        let vectorLayer = new VectorLayer({ source: vectorSource, style: selectWagonStyle });
        vectorLayer.set('name', 'wagons');
        let wagonOverlay = this.map.getOverlayById('wagonOverlay');
        let boxContent;
        if (!wagonOverlay) {
            //create box if it does not exist
            let box = document.createElement('div');
            box.id = 'ol-c-box';
            box.style.position = 'fixed';
            box.style.backgroundColor = 'white';
            box.style.borderRadius = '12px';
            box.style.padding = '18px';
            box.style.fontFamily = 'Montserrat';
            let boxClose = document.createElement('span');
            boxClose.id = 'ol-c-close';
            boxClose.textContent = '×';
            boxClose.style.position = 'absolute';
            boxClose.style.top = '-1%';
            boxClose.style.right = '2%';
            boxClose.style.fontSize = '1.6em';
            boxClose.style.color = 'darkgrey';
            boxClose.style.cursor = 'pointer';
            box.appendChild(boxClose);
            boxContent = document.createElement('div');
            boxContent.id = 'ol-c-content';
            boxContent.style.width = 'max-content';
            box.appendChild(boxContent);
            document.body.append(box);
            boxClose === null || boxClose === void 0 ? void 0 : boxClose.addEventListener('click', (event) => {
                wagonOverlay.setPosition(undefined);
            });
            wagonOverlay = new Overlay({
                element: box,
                id: 'wagonOverlay'
            });
            this.map.addOverlay(wagonOverlay);
        }
        //v2
        const displayWagonPopup = (event) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            //FIXME, not very dynamic now.. is it
            //TODO slightly better positioning
            const coordinate = event.coordinate;
            if (boxContent) {
                let feature = null;
                this.map.forEachFeatureAtPixel(event.pixel, function (i_feature) {
                    if (i_feature.get('type') === 'w')
                        feature = i_feature;
                });
                if (!feature) {
                    this.map.getOverlayById('wagonOverlay').setPosition(undefined);
                    return;
                }
                let data = feature.get('data');
                let dgsData = (_a = data.FoundWgnDGS) === null || _a === void 0 ? void 0 : _a[0]; //handle multiple... but from the backend...
                const wgnNo = data.wgnNo;
                const wgnNoFormat = "XX XX XXXX XXX-X";
                let formattedWgnNo = '';
                let zi = -1;
                for (let i = 0; i < wgnNoFormat.length; i++) {
                    if (wgnNoFormat.charAt(i) === 'X') {
                        zi += 1;
                        formattedWgnNo += wgnNo[zi];
                    }
                    else
                        formattedWgnNo += wgnNoFormat[i];
                }
                boxContent.innerHTML = `<table>
                    <tbody>
                   <tr><td>Vogn nr</td><td>${formattedWgnNo}</td></tr>
                   <tr><td>Position</td><td>${data.wgnPos}</td></tr>
                   <tr><td>Længde</td><td>${(data.rangeMax / 1000).toFixed(1)}</td></tr>
                   <tr><td>Type</td><td>${data.litra}</td></tr>
                   <tr><td>UN nr</td><td>${(_b = dgsData === null || dgsData === void 0 ? void 0 : dgsData.unnumber) !== null && _b !== void 0 ? _b : ''}</td></tr>
                   <tr><td>Navn</td><td>${(_c = dgsData === null || dgsData === void 0 ? void 0 : dgsData.properShippingName) !== null && _c !== void 0 ? _c : ''}</td></tr>
                   <tr><td>RID klasse</td><td>${(_d = dgsData === null || dgsData === void 0 ? void 0 : dgsData.unclass) !== null && _d !== void 0 ? _d : ''}</td></tr>
                   <tr><td>Pakke gruppe</td><td>${(_e = dgsData === null || dgsData === void 0 ? void 0 : dgsData.packageGrp) !== null && _e !== void 0 ? _e : ''}</td></tr>
                   <tr><td>Farenummer</td><td>${(_f = dgsData === null || dgsData === void 0 ? void 0 : dgsData.dangerNo) !== null && _f !== void 0 ? _f : ''}</td></tr>
                   <tr><td>Fareseddel</td><td>${(_g = dgsData === null || dgsData === void 0 ? void 0 : dgsData.hazardLabel.replaceAll(',', ', ')) !== null && _g !== void 0 ? _g : ''}</td></tr>
                   <tr><td>Vægt netto</td><td>${((data.grossWeight - data.tara) / 1000).toFixed(1)}</td></tr>
                   <tr><td>Vægt brutto</td><td>${(data.grossWeight / 1000).toFixed(1)}</td></tr>
                   <tr><td>UT</td><td>${(_h = data.UT) !== null && _h !== void 0 ? _h : ''}</td></tr>
                   <tr><td>Ejer</td><td>${(_j = data.holder) !== null && _j !== void 0 ? _j : ''}</td></tr>
                   </tbody>
                </table>`;
                wagonOverlay.setPosition(coordinate);
            }
        };
        const toggleHRVisibility = (event) => {
            var _a, _b;
            let newZoom = Number(this.map.getView().getZoom());
            if (newZoom < 14) {
                (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.hr-wagon-overlay').forEach((el) => {
                    el.style.display = 'none';
                });
            }
            else {
                (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll('.hr-wagon-overlay').forEach((el) => {
                    el.style.display = 'block';
                });
            }
        };
        this.map.un('singleclick', displayWagonPopup); //only add once, but run multiple times...
        this.map.on('singleclick', displayWagonPopup);
        //Slightly obnoxious way to do it
        this.map.un('moveend' /*or change:view'*/, toggleHRVisibility);
        this.map.on('moveend' /*or change:view'*/, toggleHRVisibility);
        //1
        try {
            let req = await fetchRestApi(null, { httpMethod: 'GET', path: `banedk/wagons/${stationRefno}?current=true`, picsystem: (PIC.systemId === 'udv' ? 'gtsdemo_udv' : PIC.systemId) });
            let json = await req.json();
            //assume henstilletgods for now... -> but needs to be dynamic
            let trackLayer = (_b = this.vectors) === null || _b === void 0 ? void 0 : _b.vectors.find(x => { var _a; return x.layerName === 'BDK Spor' || ((_a = x.link) === null || _a === void 0 ? void 0 : _a.includes('bdkspor.json')); }); //whey
            if (!trackLayer)
                throw Error("Could not find track layer");
            let tracks = (_d = (_c = trackLayer.VectorLayer) === null || _c === void 0 ? void 0 : _c.getSource()) === null || _d === void 0 ? void 0 : _d.getFeatures(); //not dynamic at all...
            json.henstilletgods.FoundStation.forEach((station) => {
                if (!station.FoundTracks)
                    return;
                let tracksWithWagons = station.FoundTracks.filter((track) => track.FoundWgn);
                for (let track of tracksWithWagons) {
                    let trackFeature = tracks === null || tracks === void 0 ? void 0 : tracks.find(t => t.getProperties().strkafs === Number(station.strkafs) && t.getProperties().spornummer === track.trackId);
                    if (track.FoundWgn.length === 0 || !trackFeature || !trackFeature.getGeometry)
                        continue; //print skip?
                    this.drawFeaturesOnLine(track.FoundWgn, trackFeature === null || trackFeature === void 0 ? void 0 : trackFeature.getGeometry(), vectorSource);
                }
            });
            this.map.addLayer(vectorLayer);
        }
        catch (error) {
            console.error(error);
            openChoiceBox('pic-choicebox[choicebox-x]', { isNew: true, choiceTitle: 'An error occured while fetching wagon data', choices: [{ choiceText: 'OK', choiceEvent: '' }] });
        }
    }
    createMap(iMapRef) {
        if (!this.defaultTileLayer)
            this.createDefaultMapLayer();
        this.view = new View({
            center: this.startCoords.length > 0 ? fromLonLat(this.startCoords) : this.defaultVars.mapCenter,
            zoom: typeof this.startZoom !== 'undefined' ? this.startZoom : this.defaultVars.mapZoom,
        });
        this.map =
            new Map({
                target: iMapRef,
                layers: [this.defaultTileLayer],
                view: this.view,
            });
    }
    handleMapTypeClick(iType) {
        var _a, _b, _c, _d;
        if (!this.defaultTileLayer)
            this.createDefaultMapLayer();
        /* TODO: If team tools you can use satelite */
        if (PIC.getInstance.isTeamTools) {
            if (!this.sateliteTileLayer)
                this.createSateliteMap();
            switch (iType) {
                case 'satelite':
                    (_a = this.oceanTileLayer) === null || _a === void 0 ? void 0 : _a.setVisible(true);
                    (_b = this.sateliteTileLayer) === null || _b === void 0 ? void 0 : _b.setVisible(true);
                    this.defaultTileLayer.setVisible(false);
                    break;
                case 'default':
                    (_c = this.oceanTileLayer) === null || _c === void 0 ? void 0 : _c.setVisible(false);
                    (_d = this.sateliteTileLayer) === null || _d === void 0 ? void 0 : _d.setVisible(false);
                    this.defaultTileLayer.setVisible(true);
                    this.removeAttributions();
                    break;
                default:
                    break;
            }
        }
        // Active state change for Layers modal - Map Type images
        const defaultImage = this.mapViewport.querySelector('.image-default');
        const satelliteImage = this.mapViewport.querySelector('.image-satellite');
        if (iType === 'default') {
            satelliteImage.classList.remove('active');
            defaultImage.classList.add('active');
        }
        else {
            defaultImage.classList.remove('active');
            satelliteImage.classList.add('active');
        }
    }
    addLayerControlButton() {
        let buttonDiv = document.createElement('div');
        buttonDiv.classList.add('ol-control-layer');
        render(html `
            <button class="ol-control-layer-openmodal ol-unselectable"
                @click=${this.openLayerControlModal.bind(this)}
                >${this.mapSVG.layer}</button>
                ${this.renderToolTip('Layers', ['bottom'])}
        `, buttonDiv);
        this.map.addControl(new Control({ element: buttonDiv }));
    }
    addRefreshControlButton() {
        let buttonDiv = document.createElement('div');
        buttonDiv.classList.add('ol-refresh');
        render(html `
            <button class="ol-refresh-button ol-unselectable"
                @click=${() => this.refreshAllVectorLayers()}
                >${this.mapSVG.refresh}</button>
                ${this.renderToolTip('Refresh', ['bottom'])}
        `, buttonDiv);
        this.map.addControl(new Control({ element: buttonDiv }));
    }
    addCopyrightButton() {
        let buttonDiv = document.createElement('div');
        buttonDiv.classList.add('ol-copyright');
        render(html `
            <button class="ol-copyright-button"
                @click=${() => this.setupCopyrightButton()}
                >${this.mapSVG.copyright}</button>
                ${this.renderToolTip('Copyright', ['top'])}
        `, buttonDiv);
        this.map.addControl(new Control({ element: buttonDiv }));
    }
    exportMap(format = 'png', type = 'download') {
        let filename = `${this.mapFilename}.png`;
        const myMap = this.map;
        myMap.once('rendercomplete', function () {
            const mapCanvas = document.createElement('canvas');
            const size = myMap.getSize();
            if (typeof size === 'undefined') {
                console.error('undefined map size when trying to export');
                return;
            }
            mapCanvas.width = size[0];
            mapCanvas.height = size[1];
            const mapContext = mapCanvas.getContext('2d'); //?
            Array.prototype.forEach.call(myMap.getViewport().querySelectorAll('.ol-layer canvas, canvas.ol-layer'), function (canvas) {
                if (canvas.width > 0) {
                    const opacity = canvas.parentNode.style.opacity || canvas.style.opacity;
                    mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
                    let matrix;
                    const transform = canvas.style.transform;
                    if (transform) {
                        // Get the transform parameters from the style's transform matrix
                        matrix = transform
                            .match(/^matrix\(([^\(]*)\)$/)[1]
                            .split(',')
                            .map(Number);
                    }
                    else {
                        matrix = [
                            parseFloat(canvas.style.width) / canvas.width,
                            0,
                            0,
                            parseFloat(canvas.style.height) / canvas.height,
                            0,
                            0,
                        ];
                    }
                    // Apply the transform to the export map context
                    CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix);
                    const backgroundColor = canvas.parentNode.style.backgroundColor;
                    if (backgroundColor) {
                        mapContext.fillStyle = backgroundColor;
                        mapContext.fillRect(0, 0, canvas.width, canvas.height);
                    }
                    mapContext.drawImage(canvas, 0, 0);
                }
            });
            mapContext.globalAlpha = 1;
            mapContext.setTransform(1, 0, 0, 1, 0, 0);
            if (type === 'download') {
                const link = document.createElement('a');
                link.href = mapCanvas.toDataURL();
                link.download = filename;
                link.click();
            }
            else {
                const l = '<img src="' + mapCanvas.toDataURL() + '">';
                const n = window.open();
                if (n) {
                    n.document.open();
                    n.document.write(l);
                    n.document.close();
                }
            }
        });
        myMap.renderSync();
    }
    //todo other exports than png
    addExportButton() {
        let buttonDiv = document.createElement('div');
        buttonDiv.classList.add('ol-export');
        render(html `
            <button class="ol-export-button"
                @click=${() => this.exportMap('png')} 
                >${this.mapSVG.download}</button>
                ${this.renderToolTip('Export', ['bottom'])}
        `, buttonDiv);
        this.map.addControl(new Control({ element: buttonDiv }));
    }
    addControls() {
        //Add SVG to buttons
        this.btnZoomIn.innerHTML = '';
        this.btnZoomOut.innerHTML = '';
        this.btnRotateReset.innerHTML = '';
        this.btnRotateReset.title = '';
        render(html `${this.mapSVG.plus}${this.renderToolTip('Zoom In', ['left'], { mainAxis: 25, crossAxis: 7.5 })}`, this.btnZoomIn);
        render(html `${this.mapSVG.minus}${this.renderToolTip('Zoom Out', ['left'], { mainAxis: 35, crossAxis: 7.5 })}`, this.btnZoomOut);
        render(html `${this.mapSVG.rotate}${this.renderToolTip('Reset Rotation', ['left'], { mainAxis: 45, crossAxis: 7.5 })}`, this.btnRotateReset);
        this.setCurrentPos();
        this.addLayerControlButton();
        this.addRefreshControlButton();
        this.addCopyrightButton();
        this.addExportButton();
    }
    //On first page load, hide attribution after 4s
    removeAttributions() {
        setTimeout(() => {
            if (this.attribution)
                // this.attribution.classList.add('hidden');
                this.attribution.classList.add('fade-out-left');
            setTimeout(() => {
                var _a, _b;
                (_a = this.attribution) === null || _a === void 0 ? void 0 : _a.classList.add('hidden');
                (_b = this.attribution) === null || _b === void 0 ? void 0 : _b.classList.remove('fade-out-left');
            }, 500);
        }, 4000);
    }
    setupCopyrightButton() {
        this.btnCopyright.onclick = () => {
            if (this.attribution) {
                if (this.attribution.classList.contains('hidden')) {
                    this.attribution.classList.remove('hidden');
                    this.attribution.classList.add('fade-in-left');
                    setTimeout(() => {
                        this.attribution.classList.remove('fade-in-left');
                    }, 500);
                }
                else {
                    this.attribution.classList.add('fade-out-left');
                    setTimeout(() => {
                        this.attribution.classList.add('hidden');
                        this.attribution.classList.remove('fade-out-left');
                    }, 500);
                }
            }
        };
    }
    openLayerControlModal() {
        if (this.selectLayerModal) {
            this.selectLayerModal.classList.toggle('hidden');
        }
        else {
            this.renderLayerControlModal();
        }
    }
    createLayerControlModal() {
        let modalDiv = document.createElement('div');
        modalDiv.classList.add('ol-control-layer-modal');
        modalDiv.classList.add('hidden');
        render(this.renderLayerControl(), modalDiv);
        this.map.addControl(new Control({ element: modalDiv }));
    }
    renderToolTip(iTxt, iPlacement = ['left', 'right', 'top', 'bottom'], iOffset = 4) {
        return html `<pic-tooltip .allowedPlacements=${iPlacement} .offset=${iOffset}>${iTxt}</pic-tooltip>`;
    }
    renderLayerControlModal() {
        if (this.selectLayerModal) {
            render(this.renderLayerControl(), this.selectLayerModal);
        }
        else {
            this.createLayerControlModal();
        }
    }
    renderLayerControlIcon(v) {
        var _a;
        let circle = this.mapSVG.circle(v.properties.layerColor);
        let img = html `<pic-svg class="layerArrow" .src=${(_a = v.properties.iconSrc) !== null && _a !== void 0 ? _a : ''} .width =${'15px'} .height =${'15px'} .color=${v.properties.layerColor}></pic-svg>`;
        if (v.properties.iconSrc) {
            if (v.properties.iconSrc === this.defaultVars.iconSrc) {
                return circle;
            }
            else {
                return img;
            }
        }
        else {
            return circle;
        }
    }
    renderLayerControl() {
        var _a;
        return html `
        <div class="layer-modal-container">
            <div class="layer-modal-top">
                <span class="pic-overline layer-modal-title">Map Type</span>
                <div class="layer-modal-top-items">
                    <div class="layer-modal-maptype-item" @click=${() => this.handleMapTypeClick('default')}>
                        <pic-image class="image-default active" .width=${'34px'} .height=${'34px'} .src=${'/images/map-layer-default.png'}></pic-image>
                        <span class="pic-body2">Default</span>
                    </div>
                    <div class="layer-modal-maptype-item" @click=${() => this.handleMapTypeClick('satelite')}>
                        <pic-image style=${'border-radius: 3px'} class="image-satellite" .width=${'34px'} .height=${'34px'} .src=${'/images/map-layer-satellite.png'}></pic-image>
                        <span class="pic-body2">Satellite</span>
                    </div>
                </div>
            </div>
            <hr class="divider">
            <div class="layer-modal-body">
                <span class="pic-overline layer-modal-title">Base</span>
                ${(_a = this.vectors) === null || _a === void 0 ? void 0 : _a.vectors.map(v => html `<div class="layer-modal-layer-item">
                        <pic-checkbox 
                            class='layer-modal-layer-item-checkbox'
                            .isinput__=${false} 
                            .id_=${'layer-modal-layer-item-checkbox'} 
                            .eType=${'default'} 
                            .density=${'inline'}
                            .minFitContent=${false}
                            .width=${'12px'}
                            .value=${'true'}
                            .clickAction=${new PICAction('internal', this.toggleLayer.bind(this, v))}
                        ></pic-checkbox>
                        <span 
                            class="pic-body2 layerNames"
                            @click=${() => this.zoomToLayer(v)}
                        >${v.layerName}</span>
                        ${this.renderLayerControlIcon(v)}
                    </div>
                    `)}
            </div>
        </div>   
        `;
    }
    renderOpenLayerLinks() {
        return html `
            <!-- <link rel="stylesheet" href="theme/ol.css"> -->
        `;
    }
    renderMapItems() {
        this.removeAttributions();
        this.addControls();
        this.addLayers();
        this.addOverlays();
    }
    updated() {
        if (!this.map) {
            this.createMap(this.mapRef);
            this.renderMapItems();
        }
        this.addLayers();
    }
    render() {
        return html `
            ${this.renderCSS(true)}
            ${this.renderOpenLayerLinks()}
            <div style=${styleMap(this.getMapStyle())} class="outerContainer"></div>
            <div id="tooltip" style="display: none;"></div>
            `;
    }
};
_PICMap_vectors = new WeakMap();
__decorate([
    query('.outerContainer')
], PICMap.prototype, "mapRef", void 0);
__decorate([
    query('#tooltip')
], PICMap.prototype, "tooltipContainer", void 0);
__decorate([
    query('.ol-attribution')
], PICMap.prototype, "attribution", void 0);
__decorate([
    query('.ol-viewport')
], PICMap.prototype, "mapViewport", void 0);
__decorate([
    query('.ol-zoom-in')
], PICMap.prototype, "btnZoomIn", void 0);
__decorate([
    query('.ol-zoom-out')
], PICMap.prototype, "btnZoomOut", void 0);
__decorate([
    query('.ol-rotate-reset')
], PICMap.prototype, "btnRotateReset", void 0);
__decorate([
    query('.ol-copyright')
], PICMap.prototype, "btnCopyright", void 0);
__decorate([
    query('.ol-control-layer-modal')
], PICMap.prototype, "selectLayerModal", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICMap.prototype, "width", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICMap.prototype, "height", void 0);
__decorate([
    property({ type: Array, attribute: 'coords' })
], PICMap.prototype, "startCoords", void 0);
__decorate([
    property({ converter: numberDecoder, attribute: 'zoom' })
], PICMap.prototype, "startZoom", void 0);
__decorate([
    property({ attribute: 'filename', converter: stringDecoder })
], PICMap.prototype, "mapFilename", void 0);
PICMap = __decorate([
    customElement('pic-map')
], PICMap);
export { PICMap };
//# sourceMappingURL=PICMap.js.map